import { render, staticRenderFns } from "./Registrate.vue?vue&type=template&id=c64020e2&scoped=true&"
import script from "./Registrate.vue?vue&type=script&lang=js&"
export * from "./Registrate.vue?vue&type=script&lang=js&"
import style0 from "./Registrate.vue?vue&type=style&index=0&id=c64020e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64020e2",
  null
  
)

export default component.exports